import type { AlarmContacts, EmailSuggestion } from "@visioni/a3s-alarm-schedules/schema";
import { apiRequest } from "./request";

type GetCameraContactsResponse = {
  alarm_contacts: AlarmContacts | null;
};

export const contactsApi = {
  async getCameraContacts(tenantId: string, siteId: string, cameraKey: string): Promise<AlarmContacts> {
    const response = await apiRequest<GetCameraContactsResponse>({
      method: "GET",
      path: `/api/v1/tenants/${tenantId}/sites/${siteId}/cameras/${cameraKey}/alarms/contacts`,
      logMessage: "Fetching camera contacts from:",
    });

    return (
      response.alarm_contacts ?? {
        sms_contacts: [],
        email_contacts: [],
      }
    );
  },

  async updateCameraContacts(
    tenantId: string,
    siteId: string,
    cameraKey: string,
    contacts: AlarmContacts,
  ): Promise<void> {
    await apiRequest<void>({
      method: "POST",
      path: `/api/v1/tenants/${tenantId}/sites/${siteId}/cameras/${cameraKey}/alarms/contacts`,
      body: { alarm_contacts: contacts },
      logMessage: "Updating camera contacts at:",
    });
  },

  async getEmailSuggestions(
    tenantId: string,
    siteId: string,
    cameraKey: string,
    query?: string,
  ): Promise<EmailSuggestion[]> {
    const queryString = query ? `?query=${encodeURIComponent(query)}` : "";

    return apiRequest<EmailSuggestion[]>({
      method: "GET",
      path: `/api/v1/tenants/${tenantId}/sites/${siteId}/cameras/${cameraKey}/alarms/contacts/email-suggestions${queryString}`,
      logMessage: "Fetching camera email contact suggestions from:",
    });
  },
};
